import type { BrandedConnectorOptions } from '../branded';
import type { MysqlFamilyOptions } from '../mysql';
import { createBrandedConnector } from '../branded';
import mariadb from '../mariadb';

const brands: BrandedConnectorOptions<MysqlFamilyOptions>[] = [
	{
		id: 'aws-rds-mariadb',
		name: '$t:connectors.aws-rds-mariadb.name',
		description: '$t:connectors.aws-rds-mariadb.description',
		icon: 'simple-icons:amazonrds',
		iconColor: '#527FFF',
		keywords: ['aws', 'amazon', 'rds', 'mariadb', 'relational database service', 'cloud'],
		availableSince: '2026-06-16',
		docsUrl: 'https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/USER_ConnectToMariaDBInstance.html',
		overrides: {
			connectionStringPlaceholder: 'mysql://admin:password@mydb.123456789012.us-east-1.rds.amazonaws.com:3306/dbname',
		},
	},
];

export const mariadbPresets = brands.map((brand) => createBrandedConnector(mariadb, brand));
